import { _ as f, a as _ } from "./OrSkeletonText-WYaAaljl.mjs";
import { openBlock as o, createElementBlock as r, normalizeClass as t, normalizeStyle as s } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
function m(e, l, a, c, i, p) {
  return o(), r("div", {
    ref: "root",
    class: t(e.rootStyles),
    style: s(e.rootStyle)
  }, null, 6);
}
const S = /* @__PURE__ */ n(f, [["render", m]]);
function $(e, l, a, c, i, p) {
  return o(), r("div", {
    ref: "root",
    class: t(e.rootStyles),
    style: s(e.rootStyle)
  }, null, 6);
}
const k = /* @__PURE__ */ n(_, [["render", $]]);
export {
  S as O,
  k as a
};
//# sourceMappingURL=OrSkeletonRect-D9sTxEc-.mjs.map
